import { useEffect, useState } from 'react';

const useResendTimer = (initialSeconds: number) => {
  const [resendTimer, setResendTimer] = useState<number | null>(null);
  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (resendTimer && resendTimer > 0) {
      const id = setInterval(() => {
        setResendTimer((prev) => (prev && prev > 0 ? prev - 1 : 0));
      }, 1000);

      setTimerId(id);
    } else if (timerId) {
      clearInterval(timerId);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [resendTimer]);

  const startResendTimer = () => setResendTimer(initialSeconds);

  return {
    resendTimer,
    isResendTimerActive: resendTimer && resendTimer > 0,
    startResendTimer,
  };
};

export default useResendTimer;
